import { BorderRadius, Color } from '@billy/design-system'
import styled from '@emotion/styled'

export const InvoicingSettingsPreviewWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  border-radius: ${BorderRadius.R16};
  position: relative;
  background-color: ${Color.Grey100};
  overflow: hidden;
`
